import { ButtonText } from '@nokia-csf-uxr/ccfk/Button';
import { Legend } from '@nokia-csf-uxr/ccfk/FieldSet';
import React from 'react';
import { SingleBandLinkUserContext } from '../../../contexts/SingleBandLinkContext';
import Form from 'react-bootstrap/esm/Form';
import Row from 'react-bootstrap/esm/Row';
import Container from 'react-bootstrap/esm/Container';
import Col from 'react-bootstrap/esm/Col';
import Button from 'react-bootstrap/esm/Button';
import WLDInputComponent from '../WLDInputComponent';
import { DualBandLinkUserContext } from '../../../contexts/DualBandLinkContext';

/**
 * Path details component (length & sites)
 */
export default class PropagationAccuracy extends WLDInputComponent {

    constructor(props: {band: number, bandItem: string}) {
        super(props);
    }

    render() {
        return (
            <Container className='mt-2'>
                <Row>
                    <Col>
                        <Form.Label>Propagation accuracy</Form.Label>
                        { this.props.band == 1 ?
                        <>
                            <SingleBandLinkUserContext.Consumer>
                            {(link) => (
                                <Container>
                                    <Row>
                                        <Col className="columns-section-50 ps-lg-0 pb-2 ps-0 pe-0 pe-sm-1 pb-lg-0">
                                            <Button className={link.prop_accuracy == "simple" ? "action-button" : "action-button unselected-bnt"} onClick={() => link.define("prop_accuracy", "simple")}>Simple</Button>
                                        </Col>
                                        <Col className="columns-section-50 pe-lg-0 pe-0 ps-0 ps-sm-1">
                                            <Button className={link.prop_accuracy == "advanced" ? "action-button" : "action-button unselected-bnt"} onClick={() => link.define("prop_accuracy", "advanced")}>Advanced</Button>
                                        </Col>
                                    </Row>
                                </Container>
                            )}
                            </SingleBandLinkUserContext.Consumer>
                        </>
                        :
                        <>
                            <DualBandLinkUserContext.Consumer>
                                {(link) => (
                                    <Container>
                                        <Row>
                                            <Col className="columns-section-50 ps-lg-0 pb-2 ps-0 pe-0 pe-sm-1 pb-lg-0">
                                                <Button className={link.prop_accuracy == "simple" ? "action-button" : "action-button unselected-bnt"} onClick={() => link.define("prop_accuracy", "simple")}>Simple</Button>
                                            </Col>
                                            <Col className="columns-section-50 pe-lg-0 pe-0 ps-0 ps-sm-1">
                                                <Button className={link.prop_accuracy == "advanced" ? "action-button" : "action-button unselected-bnt"} onClick={() => link.define("prop_accuracy", "advanced")}>Advanced</Button>
                                            </Col>
                                        </Row>
                                    </Container>
                                )}
                            </DualBandLinkUserContext.Consumer>
                        </>
                        }
                    </Col>
                </Row>
            </Container>
        );
    }

}
